// -----------------------------------------------------------------------------
// Anaglyphic, Netherlands @ 2023.
// See README in the root project for more information.
// -----------------------------------------------------------------------------

// Components

// Composables
import { createApp } from "vue";
// import "@/plugins/modernize/scss/style.scss";

import logoUrl from "@/assets/images/Anaglyphic_logo_sticker.png";
import navMenuUrl from "@/assets/images/Anaglyphic-menu.png";
import faviconUrl from "@/assets/images/favicon.ico";

// Plugins
import { registerPlugins } from "@/plugins";
import isoWeek from "dayjs/plugin/isoWeek";
import quarter from "dayjs/plugin/quarterOfYear";
import advancedFormat from "dayjs/plugin/advancedFormat";
import dayjs from "dayjs";
import { client } from "laravel-precognition-vue";
import { createApiClient } from "@/api/base";
import { AppMeta, useBaseStore } from "@/stores/base";
import EmptyBase from "@/ui/layouts/EmptyBase.vue";
import { Chart } from "chart.js";
import { useBrandingStore } from "@/stores/brandingStore";
import { checkBackendReachability } from "@/api/helpers/backendReachability";

Chart.defaults.font.family = "'Plus Jakarta Sans', Arial, sans-serif";
Chart.defaults.font.size = 12;
Chart.defaults.font.weight = "normal";

dayjs.extend(isoWeek);
dayjs.extend(quarter);
dayjs.extend(advancedFormat);

declare global {
	interface Window {
		appMeta: AppMeta;
	}
}

if (window.appMeta === undefined) {
	window.appMeta = {
		title: "",
		logoUrl: "",
		faviconUrl: "",
		navMenuUrl: "",
	};
}

if (!window.appMeta.title) {
	window.appMeta.title = "Anaglyphic";
}

if (!window.appMeta.logoUrl) {
	window.appMeta.logoUrl = logoUrl;
}

if (!window.appMeta.faviconUrl) {
	window.appMeta.faviconUrl = faviconUrl;
}

if (!window.appMeta.navMenuUrl) {
	window.appMeta.navMenuUrl = navMenuUrl;
}

function setFavicon(uri: string) {
	const existingFavicon = document.querySelector('link[rel="icon"]');
	if (existingFavicon) {
		document.head.removeChild(existingFavicon);
	}

	const favicon = document.createElement("link");
	favicon.rel = "icon";
	favicon.href = uri;
	document.head.appendChild(favicon);
}
setFavicon(window.appMeta.faviconUrl);

// App
// -----------------------------------------------------------------------------

client.use(createApiClient());

(async () => {
	const app = await registerPlugins(createApp(EmptyBase));

	useBaseStore().meta = window.appMeta;
	document.title = window.appMeta.title;

	app.mount("#app");
	checkBackendReachability();
	useBrandingStore().fetchCustomValues();
})();
